export default __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers@3-76026e338cf6f1ca4781a351327f19d7.png";